export default __webpack_public_path__ + "6cf48c61de59075599b281535d5502d0.svg";